import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';

export const GetProductInputValidationSchema = z.object({
  productId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the product to retrieve. Find it on a page response as `data.product.id` (see `get_checkout_page`).',
  }),
});

export type GetProductInput = z.infer<typeof GetProductInputValidationSchema>;
